import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import * as R from 'ramda'

import MissionProfileInput from 'components/form/missionProfile'
import { createNamedReducer } from 'helpers/ReducerUtil'
import { createNamedAction } from 'helpers/ActionUtil'
import missionProfileInputReducer from './reducer'
import injectReducer from 'helpers/injectReducer'
import getSelectors from './selectors'
import {
  missionProfileAdd,
  missionProfileRemove,
  missionProfileUpdate,
  powerOnAdd,
  powerOnRemove,
  powerOnUpdate,
  powerOffAdd,
  powerOffRemove,
  powerOffUpdate
} from './actions'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  const reducer = createNamedReducer(valuePath, missionProfileInputReducer)
  return injectReducer(valuePath, reducer)
}

const withConnect = (path, id) => {
  const combinedPath = combinePath(path, id)
  const valuePath = getPath(path, id)
  const {
    valuesSelector,
    labelSelector,
    hintSelector
  } = getSelectors(combinedPath)

  const missionProfileAddAction = createNamedAction(valuePath, missionProfileAdd)
  const missionProfileRemoveAction = createNamedAction(valuePath, missionProfileRemove)
  const missionProfileUpdateAction = createNamedAction(valuePath, missionProfileUpdate)
  const powerOnAddAction = createNamedAction(valuePath, powerOnAdd)
  const powerOnRemoveAction = createNamedAction(valuePath, powerOnRemove)
  const powerOnUpdateAction = createNamedAction(valuePath, powerOnUpdate)
  const powerOffAddAction = createNamedAction(valuePath, powerOffAdd)
  const powerOffRemoveAction = createNamedAction(valuePath, powerOffRemove)
  const powerOffUpdateAction = createNamedAction(valuePath, powerOffUpdate)

  const mapStateToProps = (state) => {
    return {
      title: labelSelector(state),
      values: valuesSelector(state),
      hint: hintSelector(state),
    }
  }

  const mapDispatchToProps = (dispatch) => {
    return {
      missionProfileAdd: () => dispatch(missionProfileAddAction()),
      missionProfileRemove: (index) => dispatch(missionProfileRemoveAction(index)),
      missionProfileUpdate: (index, element, value) => dispatch(missionProfileUpdateAction(index, element, value)),
      powerOnAdd: (msIndex) => dispatch(powerOnAddAction(msIndex)),
      powerOnRemove: (msIndex, index) => dispatch(powerOnRemoveAction(msIndex, index)),
      powerOnUpdate: (msIndex, index, element, value) => dispatch(powerOnUpdateAction(msIndex, index, element, value)),
      powerOffAdd: (msIndex) => dispatch(powerOffAddAction(msIndex)),
      powerOffRemove: (msIndex, index) => dispatch(powerOffRemoveAction(msIndex, index)),
      powerOffUpdate: (msIndex, index, element, value) => dispatch(powerOffUpdateAction(msIndex, index, element, value))
    }
  }

  return connect(mapStateToProps, mapDispatchToProps)
}

// export { UPDATE_VALUE } from './constants'
export { getValuesSelector } from './selectors'
export { default as MissionProfileInput } from 'components/form/missionProfile'
export {
  withConnect,
  withReducer
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
  withConnect(path, id)
)(MissionProfileInput))
